import { keepPreviousData, useQuery } from '@tanstack/react-query';

import { api, unwrap, unwrapPage } from '@/api/client';
import type { components, operations } from '@/api/schema';

export type Resumen = components['schemas']['ReportsOverview'];
export type Estadisticas = components['schemas']['ReportsStats'];
export type ListaOpiniones = components['schemas']['FeedbackList'];
export type ListaEventos = components['schemas']['SecurityEventList'];
export type FiltrosOpiniones = NonNullable<operations['getAdminFeedback']['parameters']['query']>;
export type FiltrosEventos = NonNullable<
  operations['getAdminSecurityEvents']['parameters']['query']
>;

export function useResumenInicio() {
  return useQuery({
    queryKey: ['reportes', 'inicio'],
    queryFn: () => unwrap<Resumen>(api.GET('/api/v1/admin/reports/overview')),
    staleTime: 60_000,
  });
}

export function useEstadisticas(query: { from?: string; to?: string }) {
  return useQuery({
    queryKey: ['reportes', 'estadisticas', query],
    queryFn: () =>
      unwrap<Estadisticas>(api.GET('/api/v1/admin/reports/stats', { params: { query } })),
    placeholderData: keepPreviousData,
  });
}

export function useOpiniones(query: FiltrosOpiniones) {
  return useQuery({
    queryKey: ['reportes', 'opiniones', query],
    queryFn: () =>
      unwrapPage<ListaOpiniones>(api.GET('/api/v1/admin/feedback', { params: { query } })),
    placeholderData: keepPreviousData,
  });
}

export function useEventos(query: FiltrosEventos) {
  return useQuery({
    queryKey: ['reportes', 'eventos', query],
    queryFn: () =>
      unwrapPage<ListaEventos>(api.GET('/api/v1/admin/security-events', { params: { query } })),
    placeholderData: keepPreviousData,
  });
}
